// extracted by mini-css-extract-plugin
export default {"reportDownload":"ReportDownload_reportDownload__QC9+T","reportLabel":"ReportDownload_reportLabel__7aPvb","reportLink":"ReportDownload_reportLink__JbG-j"};